import { Action, createReducer, on } from "@ngrx/store";
import * as fromActions from './roomchampions.actions';
import * as fromState from './roomchampions.state';

const roomchampionsReducer = createReducer(
    fromState.getInitialRoomchampionsState(),
    on(
        fromActions.loadManySuccess,
        (state, { items }) => {
            return fromState.adapter.upsertMany(items!.map(item => {
                return { ...item, id: item.requestId } as fromState.RoomchampionsEntity
            }), state);
        }),
);

export function reducer(state: fromState.RoomchampionsState | undefined, action: Action) {
    return roomchampionsReducer(state, action);
}